import axios from 'axios'

export const vueAxios = {
    install(app) {
        app.config.globalProperties.axios = axios
    }
}
